import React, { useState } from 'react';
import { useAuth } from './auth_context';
import { Navigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { CircularProgress } from '@mui/material';
import { ErrorDialog } from 'components/shared';

interface ProtectedRouteProps {
  element: JSX.Element;
}

interface DialogButtonConfig {
  text: string;
  action: () => void;
  color:
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning';
}

interface ErrorDialogState {
  open: boolean;
  title: string;
  message1: string;
  message2?: string | null;
  button1: DialogButtonConfig;
  button2?: DialogButtonConfig | null;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const { isAuthenticated, isSessionValidating, } =
    useAuth();

  const [errorDialogState] = useState<ErrorDialogState>({
    open: false,
    title: '',
    message1: '',
    button1: {
      text: '',
      action: () => { },
      color: 'inherit',
    },
    button2: null,
  });

  const [showErrorDialog] = useState(false);

  // useEffect(() => {
  //   const validateAuth = async () => {
  //     const result = await checkAuthStatus();

  //   validateAuth();
  // }, [checkAuthStatus, logout]);

  if (isSessionValidating) {
    return <CircularProgress />;
  }

  if (!isAuthenticated && !showErrorDialog) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }


  return (
    <>
      {element}

      <ErrorDialog
        open={errorDialogState.open}
        title={errorDialogState.title}
        message1={errorDialogState.message1}
        {...(errorDialogState.message2 && {
          message2: errorDialogState.message2,
        })}
        button1Text={errorDialogState.button1.text}
        button1Color={errorDialogState.button1.color}
        button1Action={errorDialogState.button1.action}
        {...(errorDialogState.button2 && {
          button2Action: errorDialogState.button2.action,
          button2Text: errorDialogState.button2.text,
          button2Color: errorDialogState.button2.color,
        })}
      />
    </>
  );
};

export default ProtectedRoute;
